var map = {
	"./Codingtech1.webp": 3715,
	"./Sham.webp": 5534,
	"./background.webp": 8256,
	"./chappal.webp": 9073,
	"./chat.webp": 4355,
	"./contactimage.webp": 7634,
	"./iuq-logo.png": 3967,
	"./iuq-logom.png": 732,
	"./maindp.webp": 7801,
	"./portfolio.webp": 3522,
	"./user-1.jpg": 3018,
	"./user-2.jpg": 8117,
	"./user-3.jpg": 8549
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;